import { render } from "./IconInstagram.vue?vue&type=template&id=bb77a7ae"
import script from "./IconInstagram.vue?vue&type=script&lang=js"
export * from "./IconInstagram.vue?vue&type=script&lang=js"
script.render = render

export default script